module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.status === 'val') ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100px",
      "height": "50px"
    }
  }, [_c('text', {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-size": "24px"
    },
    attrs: {
      "x": "10",
      "y": "20",
      "stroke": _vm.color
    }
  }, [_vm._v("VAL")])]) : _vm._e(), _vm._v(" "), (_vm.status === 'sub') ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100px",
      "height": "50px"
    }
  }, [_c('text', {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-size": "24px"
    },
    attrs: {
      "x": "10",
      "y": "20",
      "stroke": _vm.color
    }
  }, [_vm._v("SUB")])]) : _vm._e(), _vm._v(" "), (_vm.status === 're') ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100px",
      "height": "50px"
    }
  }, [_c('text', {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-size": "24px"
    },
    attrs: {
      "x": "10",
      "y": "20",
      "stroke": _vm.color
    }
  }, [_vm._v("RE")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1934fa27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/StatusIcon.vue
// module id = 3042
// module chunks = 0